//
//
//
//
//
//
//
//
//
//
//
//


export default {
	name: 'Listing',
	props: {
		listing: Object
	},
	data() {
		return {}
	},
	computed: {
		externalLink() {
			if (this.listing.externalLink) {
				return "_blank";
			} else {
				return "";
			}
		}
	},
	methods: {},
	mounted() {}
}
